import { createAPI } from '@common'
export default {
  // 获取文件夹
  getFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bvuipsjuz0gpmefst0benjo', 'GET', config),
  // 获取根文件夹
  getFoldersRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 获取子文件夹
  getE5Folder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60gpmefst', 'GET', config),
  // 获取列表数据
  postAuthorityList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bvuipsjuz0mjtu', 'POST', config),
  // 获取操作列表
  getE5Actions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60bdujpot', 'GET', config),
   
}
